

import PropTypes from "prop-types";
import {Dropdown} from "primereact/dropdown";


export function MonthSelect(props) {
    const monthList = [
        {id: 1, month: "January"},
        {id: 2, month: "February"},
        {id: 3, month: "March"},
        {id: 4, month: "April"},
        {id: 5, month: "May"},
        {id: 6, month: "June"},
        {id: 7, month: "July"},
        {id: 8, month: "August"},
        {id: 9, month: "September"},
        {id: 10, month: "October"},
        {id: 11, month: "November"},
        {id: 12, month: "December"},
        {id: 13, month: "All"},
    ]
    const handleChange = (event) => {
        const myValue = monthList.find(x => x.id === event.target.value)
        props.setSelectedMonth({
            id: myValue.id,
            month: myValue.month,
        })
    };
    return (
            <Dropdown value={props.selectedMonth.id} onChange={handleChange} options={monthList}
                      optionLabel="month" optionValue="id" disabled={props.disable} style={{fontSize: '1vw'}}
                      panelClassName=" flex-1 " tooltip="Select onth" variant="filled" className="flex  h-2rem align-items-center justify-content-center mr-2" />
    )

}

MonthSelect.propTypes = {
    selectedMonth: PropTypes.object.isRequired,
    setSelectedMonth: PropTypes.func.isRequired,
    disable: PropTypes.bool.isRequired,


}
